import { createContext } from 'react';

import { PieChartCustomTooltipConfig } from '../types/pie-chart.config.js';

export const DEFAULT_TOOLTIP_CONFIG: PieChartCustomTooltipConfig = {
  hidden: false,
};

export const PieChartTooltipContext =
  createContext<PieChartCustomTooltipConfig>(DEFAULT_TOOLTIP_CONFIG);
